import { h } from 'preact';

const Start = ({ start }) => {
    return (
        <div>
        <img style="padding-bottom:15px;" src="/assets/aon_logo_2.png"/>
        <img style="max-width:100%;" src="/assets/cdc-start-banner.png"/>
            <h3 className="text-center paddAbove">Could a CDC scheme be right for you and your workforce?</h3>
            <p className="text-center paddBelow">Take the short quiz to find out</p>
            <div className="d-flex justify-content-center">
                <button type="button" className="btn btn-primary" onClick={() => start(true)}>Start</button>
            </div>
        </div>
    );
}

export default Start;
